import React from "react";
import { useNavigate } from "react-router-dom";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import "../styles/footer.css";

const Footer = () => {
  const navigate = useNavigate();

  const navLinks = [
    { label: "Home", path: "/" },
    { label: "About", path: "/about" },
    { label: "Services", path: "/services" },
    { label: "Contact", path: "/contact" },
  ];

  const socialLinks = [
    { icon: FaInstagram, url: "https://www.instagram.com/king_queen_pkd/", name: "Instagram", color: "#E4405F" },
    { icon: FaWhatsapp, url: "https://wa.me/918891064655", name: "WhatsApp", color: "#25D366" },
  ];

  return (
    <footer className="ft-root">

      {/* ── TOP MARQUEE STRIP ── */}
      <div className="ft-marquee">
        <div className="ft-marquee-track">
          {["Hair Styling", "✦", "Bridal Makeup", "✦", "Skin Care", "✦",
            "Beard Grooming", "✦", "Hair Treatments", "✦", "Facials", "✦",
            "Hair Styling", "✦", "Bridal Makeup", "✦", "Skin Care", "✦",
            "Beard Grooming", "✦", "Hair Treatments", "✦", "Facials", "✦"].map((item, i) => (
              <span key={i} className={item === "✦" ? "ft-dot" : "ft-marquee-item"}>
                {item}
              </span>
            ))}
        </div>
      </div>

      {/* ── MAIN FOOTER BODY ── */}
      <div className="ft-body">

        {/* Brand Column */}
        <div className="ft-brand">
          <img src="/assets/minilogo.png" alt="King & Queen logo" className="ft-logo" />
          <h2 className="ft-brand-name">King &amp; Queen</h2>
          <p className="ft-brand-tagline">Unisex Family Salon &amp; Bridal Studio</p>
          <p className="ft-brand-desc">
            Where artistry meets elegance. Premium beauty services crafted for every occasion,
            every individual, every story.
          </p>
          <div className="ft-socials">
            {socialLinks.map((s, i) => (
              <a
                key={i}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                className="ft-social"
                aria-label={s.name}
                style={{ '--hover-color': s.color }}
              >
                <s.icon className="ft-social-icon" />
              </a>
            ))}
          </div>
        </div>

        {/* Nav Column */}
        <div className="ft-col">
          <h4 className="ft-col-title">Navigation</h4>
          <ul className="ft-nav-list">
            {navLinks.map((l, i) => (
              <li key={i}>
                <button className="ft-nav-link" onClick={() => navigate(l.path)}>
                  <span className="ft-nav-arrow">→</span> {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Column */}
        <div className="ft-col">
          <h4 className="ft-col-title">Visit Us</h4>
          <address className="ft-address">
            <p>King and Queen Salon</p>
            <p>SM Arcade, 2nd Floor</p>
            <p>Near Casaba Police Station</p>
            <p>Pudussery, Palakkad, Kerala</p>
          </address>
          <div className="ft-contact-links">
            <a href="tel:+918891064655" className="ft-contact-item">+91 88910 64655</a>
            <a href="mailto:suresh94475@gmail.com" className="ft-contact-item">suresh94475@gmail.com</a>
          </div>
        </div>

        {/* Hours Column */}
        <div className="ft-col">
          <h4 className="ft-col-title">Hours</h4>
          <div className="ft-hours">
            {[
              ["Mon – Sun", "9:00 AM – 9:00 PM"]
              // ["Sunday", "9:00 AM – 6:00 PM"],
            ].map(([day, hrs]) => (
              <div key={day} className="ft-hours-row">
                <span>{day}</span>
                <span>{hrs}</span>
              </div>
            ))}
          </div>
          <button className="ft-book-btn" onClick={() => navigate("/contact")}>
            Book a Slot →
          </button>
        </div>

      </div>

      {/* ── DIVIDER ── */}
      <div className="ft-divider">
        <span className="ft-divider-line" />
        <span className="ft-divider-mark">✦</span>
        <span className="ft-divider-line" />
      </div>

      {/* ── BOTTOM BAR ── */}
      <div className="ft-bottom">
        <p className="ft-copy">
          © 2026 King &amp; Queen · All rights reserved.
        </p>

        <p className="ft-credit">
          Developed by MPeoples Business Solutions Pvt Ltd
        </p>

        <div className="ft-legal">
          <button
            className="ft-legal-link"
            onClick={() => navigate("/privacypolicyterms")}
          >
            Privacy Policy ↗
          </button>
        </div>
      </div>

    </footer>
  );
};

export default Footer;